import { render, staticRenderFns } from "./PlanSettingsIcon.vue?vue&type=template&id=89f229a4&scoped=true"
import script from "./PlanSettingsIcon.vue?vue&type=script&lang=js"
export * from "./PlanSettingsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f229a4",
  null
  
)

export default component.exports